// src/components/Navbar.jsx
import React from 'react';

const Navbar = () => {
  return (
    <nav className="navbar">
     
      <div className="logo">
      <h1>Anti Ai</h1>
      </div>
    </nav>
  );
};

export default Navbar;
